import { contactNumberChecker } from "../formatter/Formatter";

const safeParseFloat = (value: any): number => parseFloat(value) || 0;

const safeContact = (value: string | undefined) =>
  contactNumberChecker((value ?? "").toString()) === "NONE"
    ? ""
    : (value ?? "").toString();

type FieldMapping = {
  refno: (data: any) => string | undefined;
  sndrFName: (data: any) => string | undefined;
  sndrMName: (data: any) => string | undefined;
  sndrLName: (data: any) => string | undefined;
  sndrBusinessName?: (data: any) => string | undefined;
  sndrContactNo: (data: any) => string | undefined;
  rcvrFName: (data: any) => string | undefined;
  rcvrMName: (data: any) => string | undefined;
  rcvrLName: (data: any) => string | undefined;
  rcvrContactNo: (data: any) => string | undefined;
  amount: (data: any) => number;
  others?: (data: any) => string | undefined;
};

export const fileSourceMapping: Record<string, FieldMapping> = {
  BILLSPAYMENT: {
    refno: (d) => d["Reference No."]?.toString(),
    sndrFName: (d) => d["Payor's First Name"],
    sndrMName: (d) => d["Payor's Middle Name"],
    sndrLName: (d) => d["Payor's Last Name"],
    sndrContactNo: () => "",
    rcvrFName: (d) => d["Account's First Name"],
    rcvrMName: (d) => d["Account's Middle Name"],
    rcvrLName: (d) => d["Account's Last Name"],
    rcvrContactNo: (d) => d["Account's Contact No."],
    amount: (d) => safeParseFloat(d["Amount Paid"]),
  },
  DISBURSEMENT: {
    refno: (d) => d["REFERENCE #"]?.toString(),
    sndrFName: (d) => d["SENDER FIRST NAME"],
    sndrMName: (d) => d["SENDER MIDDLE NAME"],
    sndrLName: (d) => d["SENDER LAST NAME"],
    sndrBusinessName: (d) => d["SENDER BUSINESS NAME"] ?? null,
    sndrContactNo: (d) => safeContact(d["SENDERS CONTACT #"]),
    rcvrFName: (d) => d["RECEIVERS FIRST NAME"],
    rcvrMName: (d) => d["RECEIVERS MIDDLE NAME"],
    rcvrLName: (d) => d["RECEIVERS LAST NAME"],
    rcvrContactNo: (d) => safeContact(d["RECEIVERS CONTACT #"]),
    amount: (d) => safeParseFloat(d["PRINCIPAL AMOUNT"]),
    others: (d) => d["OTHERS"] ?? undefined,
  },
  "MONEY EXCHANGE": {
    refno: (d) => d.paymentKey,
    sndrFName: (d) => d.senderFName,
    sndrMName: (d) => d.senderLName2,
    sndrLName: (d) => d.senderLName,
    sndrContactNo: () => "",
    rcvrFName: (d) => d.beneficiaryFName,
    rcvrMName: (d) => d.beneficiaryLName2,
    rcvrLName: (d) => d.beneficiaryLName,
    rcvrContactNo: (d) => safeContact(d.beneficiaryPhone?.toString()),
    amount: (d) => safeParseFloat(d.amount),
  },
  Pay2Home: {
    refno: (d) => d.ktpn,
    sndrFName: (d) => d.senderFName,
    sndrMName: (d) => d.senderMName,
    sndrLName: (d) => d.senderLName,
    sndrContactNo: () => "",
    rcvrFName: (d) => d.receiverFName,
    rcvrMName: (d) => d.receiverMName,
    rcvrLName: (d) => d.receiverLName,
    rcvrContactNo: (d) => safeContact(d.receiverPhoneNo?.toString()),
    amount: (d) => safeParseFloat(d.principalAmt),
  },
};
